// MODULES
import React from "react";

// HELPERS
import {createClassName, getPropertiesByPrefix, parseDraftDataPropsToFieldState, delay} from "@helpers/utils";
import fulfillmentCheck from "./AmountChooser.fulfillment";
import DefaultFields from "../../../components/DefaultFields/DefaultFields";
import PropTypes from "prop-types";
import Select from "../../../../../components/Select/Select";
import NumberField from "../../../components/NumberField/NumberField";
import EditableField from "../../../components/EditableField/EditableField";
import * as CobHelpers from "../../../Cob.helpers";
import CheckboxWithName from "../../../components/CheckboxWithName/CheckboxWithName";

export default class AmountChooser extends React.PureComponent
{
    static propTypes = {
        variables: PropTypes.object.isRequired
    };

    static companyExclusive = false;
    static privateExclusive = false;

    static fields = _getFields();
    state = _getInitialState.call(this);

    componentDidUpdate(prevProps, prevState)
    {
        const {props, state} = this;
        const {id, onChange} = props;

        if (prevState.fields !== state.fields)
        {
            onChange(id, {...state}, fulfillmentCheck(props, state));
        }

        if (prevProps.draftData !== props.draftData)
        {
            if (props.draftData)
            {
                // get the draftData props specific to this section only
                const draftDataProps = getPropertiesByPrefix(props.draftData, ["futur_insured_", "checkbox_"]);
                // parse the draftData props into state.fields
                const newFieldsState = parseDraftDataPropsToFieldState(this.state.fields, draftDataProps);

                this.setState(
                    {
                        fields: {
                            ...newFieldsState
                        }
                    },
                    async () =>
                    {
                        await delay(200);
                        onChange(id, {...this.state}, fulfillmentCheck(this.props, this.state));
                    }
                );
            }
        }
    }

    render()
    {
        const {props, state} = this;
        const {title} = props;

        const classes = createClassName("Cob-Fees", {
            "Cob-View": true,
            "fulfilled": state.isFulfilled
        });

        const insurancesForDisplay = [];

        for (const key in state.fields.insurances)
        {
            insurancesForDisplay.push({
                label: state.fields.insurances[key].insuranceNumber,
                value: state.fields.insurances[key].insuranceNumber
            });
        }

        return (
            <div className={classes}>
                <DefaultFields fields={this.constructor.fields} />

                <div className="Cob-Fields">
                    <h2>{title}</h2>

                    <p style={{marginTop: "0"}}>
                        Observera att Futur Pension inte garanterar att helåterköp eller delåterköp sker inom en exakt tidsram, detta då
                        återköp är beroende av hantering hos depåförande institut vars handläggningstid ej styrs av Futur Pension.
                    </p>

                    <p>
                        <strong>Välj försäkring och belopp</strong>
                    </p>

                    <div style={{
                        width: "100%",
                        flexDirection: "row",
                        alignItems: "flex-start"
                    }}>
                        <div style={{
                            width: "50%",
                            flexDirection: "column"
                        }}>
                            <Select name="futur_insurance_number"
                                    label="Försäkringsnummer"
                                    style={{marginRight: "10px"}}
                                    selectedIndex={state.fields.selectedInsurance ? (insurancesForDisplay.map(c => c.value).indexOf(state.fields.selectedInsurance.insuranceNumber)) : -1}
                                    options={insurancesForDisplay}
                                    onChange={this._onSelectInsurance}
                            />
                            <input type={"hidden"} name={"futur_insurance_number"}
                                   value={state.fields.selectedInsurance ? state.fields.selectedInsurance.insuranceNumber : ""} />

                            <div style={{
                                width: "100%",
                                flexDirection: "column",
                                alignItems: "flex-start"
                            }}>
                                <CheckboxWithName
                                    label="Helåterköp (100%)"
                                    name="futur_withdrawal_type"
                                    value={"Full"}
                                    checked={state.fields.futur_withdrawal_type.checked}
                                    onChange={this._onCheckboxChange}
                                    disabled={state.fields.selectedInsurance == null}
                                    style={{margin: "10px 0 5px"}}
                                />
                                <input type={"hidden"} name={"futur_withdrawal_type"} value={state.fields.futur_withdrawal_type.checked ? "Full" : "Partial"} />
                                {state.fields.futur_withdrawal_type.checked && (
                                    <span style={{
                                        fontSize: "11px",
                                        width: "100%"
                                    }}>
                                        Försäkringen annulleras och upplupna avgifter dras av.
                                    </span>
                                )}
                            </div>
                        </div>

                        <div style={{width: "50%"}}>
                            <EditableField
                                name="futur_withdrawal_amount"
                                label="Belopp"
                                className="amount"
                                Component={NumberField}
                                value={state.fields.futur_withdrawal_type.checked ? "" : (state.fields.futur_withdrawal_amount || "")}
                                valid={
                                    state.fields.futur_withdrawal_type.checked || state.fields.selectedInsurance == null || state.fields.futur_withdrawal_amount === ""  ? null : (
                                        state.fields.futur_withdrawal_amount >= state.fields.selectedInsurance.minimumAmount &&
                                        state.fields.futur_withdrawal_amount <= state.fields.selectedInsurance.maximumAmount
                                    )
                                }
                                disabled={state.fields.futur_withdrawal_type.checked || state.fields.selectedInsurance == null}
                                onChange={this._onFieldChange}
                                onBlur={this._onFieldBlur}
                            />

                            {state.fields.selectedInsurance != null && (
                                <React.Fragment>
                                    <div style={{
                                        width: "100%",
                                        flexDirection: "row"
                                    }}>
                                         <span style={{
                                             fontSize: "11px",
                                             width: "100%",
                                             padding: "5px 3px 0"
                                         }}>
                                            <strong>Lägst:</strong> {state.fields.selectedInsurance.minimumAmount.toLocaleString("sv-SE")} kr<br />
                                        </span>
                                        <span style={{
                                            fontSize: "11px",
                                            width: "100%",
                                            padding: "5px 3px 0",
                                            textAlign: "right"
                                        }}>
                                            <strong>Högst:</strong> {state.fields.selectedInsurance.maximumAmount.toLocaleString("sv-SE")} kr<br />
                                        </span>
                                    </div>
                                </React.Fragment>
                            )}

                        </div>
                    </div>

                </div>
            </div>
        );
    }

    _onFieldChange = (name, value) =>
    {
        /**
         * For the single deposit and monthly savings field treat zero as if the value has not been entered
         */
        if ((name === "futur_withdrawal_amount") && value === "0")
        {
            value = "";
        }
        CobHelpers.onViewFieldChange.call(this, name, value);
    };

    _onFieldBlur = (name) =>
    {
        CobHelpers.onViewFieldBlur.call(this, name);
    };

    _onSelectInsurance = (option) =>
    {
        let selected = this.state.fields.selectedInsurance;
        for (const key in this.state.fields.insurances)
        {
            if (this.state.fields.insurances[key].insuranceNumber === option.value)
            {
                selected = this.state.fields.insurances[key];
                break;
            }
        }

        this.setState({
            fields: {
                ...this.state.fields,
                selectedInsurance: selected
            }
        });
    };

    _fieldValidator = (name, value) =>
    {
        return value.length > 0;
    };

    _onCheckboxChange = (name, checked) => {
        this.setState({
            fields: {
                ...this.state.fields,
                [name]: {...this.state.fields[name], checked}
            }
        });
    };
}

function _getFields()
{
    return [];
}

function _getInitialState()
{
    if (this.props.prevState)
    {
        return {...this.props.prevState};
    }

    const insurances = this.props.variables.insurances ? this.props.variables.insurances : [];

    return {
        validFields: {},

        fields: {
            insurances: insurances,
            selectedInsurance: insurances.length === 1 ? insurances[0] : null,
            futur_withdrawal_amount: "",
            futur_insurance_number: "",
            futur_withdrawal_type:  {
                checked: false
            }
        }
    };
}


// WEBPACK FOOTER //
// ./src/routes/Cob/views/Futur/Withdrawal/AmountChooser.js